(function () {
  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function rootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function setMainImage(root, image, srcset, alt) {
    var mainImage = qs(root, '[data-compact-main-image]');

    if (!mainImage || !image) return;

    mainImage.src = image;

    if (srcset) {
      mainImage.srcset = srcset;
    }

    if (alt) {
      mainImage.alt = alt;
    }
  }

  function chooseThumb(root, thumb) {
    if (!thumb) return;

    qsa(root, '[data-compact-thumb]').forEach(function (otherThumb) {
      otherThumb.classList.remove('is-active');
      otherThumb.setAttribute('aria-pressed', 'false');
    });

    thumb.classList.add('is-active');
    thumb.setAttribute('aria-pressed', 'true');

    setMainImage(
      root,
      thumb.getAttribute('data-image'),
      thumb.getAttribute('data-image-srcset'),
      thumb.getAttribute('data-image-alt')
    );
  }

  function getActiveThumbIndex(root) {
    var thumbs = qsa(root, '[data-compact-thumb]');

    var activeIndex = thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-active');
    });

    return activeIndex >= 0 ? activeIndex : 0;
  }

  function moveImage(root, direction) {
    var thumbs = qsa(root, '[data-compact-thumb]');

    if (!thumbs.length) return;

    var nextIndex = getActiveThumbIndex(root) + direction;

    if (nextIndex < 0) {
      nextIndex = thumbs.length - 1;
    }

    if (nextIndex >= thumbs.length) {
      nextIndex = 0;
    }

    chooseThumb(root, thumbs[nextIndex]);
  }

  function setVariant(root, control) {
    if (!control) return;

    var hiddenVariantInput = qs(root, '[data-compact-variant-id]');
    var price = qs(root, '[data-compact-price]');
    var addButton = qs(root, '[data-compact-add-button]');
    var addLabel = qs(root, '[data-compact-add-label]');
    var value = control.value || control.getAttribute('data-variant-id');

    if (!value) return;

    if (hiddenVariantInput) {
      hiddenVariantInput.value = value;
    }

    qsa(root, '[data-compact-variant-radio]').forEach(function (radio) {
      var isActive = radio.value === value;
      radio.checked = isActive;
    });

    qsa(root, '[data-compact-variant-label]').forEach(function (label) {
      var isActive = label.getAttribute('data-variant-id') === value;
      label.classList.toggle('is-active', isActive);
    });

    if (price && control.getAttribute('data-price')) {
      price.textContent = control.getAttribute('data-price');
    }

    var available = control.getAttribute('data-available') === 'true';

    if (addButton) {
      addButton.disabled = !available;
    }

    if (addLabel) {
      addLabel.textContent = available
        ? addButton.getAttribute('data-compact-add-default')
        : 'Sold out';
    }

    var giftButton = qs(root, '[data-compact-gift-button]');
    var giftLabel = qs(root, '[data-compact-gift-label]');

    if (giftButton) {
      giftButton.disabled = !available;
    }

    if (giftButton && giftLabel) {
      giftLabel.textContent = available
        ? giftButton.getAttribute('data-compact-gift-default')
        : 'Sold out';
    }

    setMainImage(
      root,
      control.getAttribute('data-image'),
      control.getAttribute('data-image-srcset'),
      control.getAttribute('data-image-alt')
    );
  }

  function addCurrentProductToCart(root) {
    var variantInput = qs(root, '[data-compact-variant-id]');
    var quantityInput = qs(root, '[name="quantity"]');

    if (!variantInput || !variantInput.value) {
      return Promise.reject(new Error('Please choose a product option.'));
    }

    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (!quantity || quantity < 1) {
      quantity = 1;
    }

    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantInput.value),
        quantity: quantity
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('This product could not be added to your basket.');
      }

      return response.json();
    });
  }

  function initProduct(root) {
    if (root.__compactProductInit) return;

    root.__compactProductInit = true;

    var prevButton = qs(root, '[data-compact-prev]');
    var nextButton = qs(root, '[data-compact-next]');
    var giftButton = qs(root, '[data-compact-gift-button]');
    var giftLabel = qs(root, '[data-compact-gift-label]');

    qsa(root, '[data-compact-thumb]').forEach(function (thumb) {
      thumb.setAttribute(
        'aria-pressed',
        thumb.classList.contains('is-active') ? 'true' : 'false'
      );

      thumb.addEventListener('click', function () {
        chooseThumb(root, thumb);
      });

      thumb.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          chooseThumb(root, thumb);
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveImage(root, -1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveImage(root, 1);
        }
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        moveImage(root, -1);
      });

      prevButton.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          moveImage(root, -1);
        }
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        moveImage(root, 1);
      });

      nextButton.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          moveImage(root, 1);
        }
      });
    }

    if (giftButton) {
      giftButton.addEventListener('click', function () {
        var giftUrl = giftButton.getAttribute('data-compact-gift-url');

        if (!giftUrl) return;

        giftButton.disabled = true;

        if (giftLabel) {
          giftLabel.textContent = 'Adding...';
        }

        addCurrentProductToCart(root)
          .then(function () {
            var redirectUrl = new URL(giftUrl, window.location.origin);

            if (!redirectUrl.searchParams.has('return_url')) {
              redirectUrl.searchParams.set('return_url', rootUrl() + 'cart');
            }

            window.location.href = redirectUrl.toString();
          })
          .catch(function (error) {
            window.alert(error.message || 'This product could not be added to your basket.');
            giftButton.disabled = false;

            if (giftLabel) {
              giftLabel.textContent = giftButton.getAttribute('data-compact-gift-default') || 'Send as a gift';
            }
          });
      });
    }

    qsa(root, '[data-compact-variant-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        setVariant(root, radio);
      });
    });
  }

  function init() {
    qsa(document, '[data-harris-compact-product]').forEach(initProduct);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  window.HarrisCompactProduct = {
    init: init
  };
})();
